<div class="photo">
    <img #avatar class="icon" (click)="takePicture()">
    <input #camerainput type="file" style="display: none;" accept="image/*" (change)="changePhoto($event)">
    <div class="avatarbuttons">
        <button mat-raised-button color="accent" class="avatarbutton" (click)="takePicture()">{{gotImage ? 'Change' : 'Add'}}</button>
        <button [disabled]="!gotImage" mat-raised-button color="accent" class="avatarbutton" (click)="clearAvatar()">Clear</button>
    </div>
</div>
